import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Collapse,
  Form,
  Input,
  message,
  Modal,
  Select,
  Slider,
  Space,
  Typography,
} from "antd";
import { SliderPicker } from "react-color";
import * as xmlbuilder from "xmlbuilder2";
import { useLocalStorage } from "@rehooks/local-storage";
import { v4 as uuidv4 } from "uuid";
import firebase from "firebase";
import { CreativeQrCode } from "./CreativeQrCode";
import AceEditor from "react-ace";
import beautify from "js-beautify";
import { cancelable, CancelablePromiseType } from "cancelable-promise";
import { RedoOutlined } from "@ant-design/icons";
import { CreativesListComponent } from "./components/CreativesListComponent";
import { StorageItem } from "./list";
import axios from "axios";
import { isEmpty, clone, isArray, each } from "lodash";
import { useForm } from "antd/es/form/Form";

export const MediaFileComponent: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
}> = ({ data, onChange }) => {
  const handleTextChange = (key: string) => (e: any) => {
    handleChange(key)(e.target.value);
  };

  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };

  return (
    <div>
      <div>
        <Input
          value={data?.["#"]?.replace("<![CDATA[", "")?.replace("]]>", "")}
          placeholder={"MediaFile data"}
          onChange={(e) => {
            handleChange("#")(e.target?.value);
          }}
        />
      </div>
      <Space style={{ marginTop: 16 }} wrap>
        <Input
          value={data?.["@width"]}
          placeholder={"MediaFile width"}
          onChange={handleTextChange("@width")}
        />
        <Input
          value={data?.["@height"]}
          placeholder={"MediaFile height"}
          onChange={handleTextChange("@height")}
        />
        <Select value={data?.["@type"]} onChange={handleChange("@type")}>
          <Select.Option value={"video/mp4"}>video/mp4</Select.Option>
        </Select>
      </Space>
    </div>
  );
};

export const CreativeComponent: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
}> = ({ data, onChange }) => {
  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };

  return (
    <div>
      <div>
        <Typography.Text strong>Duration</Typography.Text>
        <Slider
          value={data?.["Duration"]?.replace("00:00:", "")}
          onChange={(value: number) => {
            handleChange("Duration")(
              `00:00:${value < 10 ? "0" + value : value}`
            );
          }}
          min={0}
          max={60}
          step={1}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <Input
          value={data?.["VideoClicks"]?.["ClickThrough"]}
          placeholder={"Click through url"}
          onChange={(e) => {
            handleChange("VideoClicks")({ ClickThrough: e.target.value });
          }}
        />
      </div>
      <MediaFileComponent
        data={data?.["MediaFiles"]?.["MediaFile"]}
        onChange={(value) => {
          handleChange("MediaFiles")({ MediaFile: value });
        }}
      />
    </div>
  );
};

export const CompanionResourceComponent: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
  style: React.CSSProperties;
}> = ({ data, onChange, style }) => {
  const handleTextChange = (key: string) => (e: any) => {
    handleChange(key)(e.target.value);
  };

  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };

  return (
    <div style={{ ...style, display: "flex" }}>
      <Select
        style={{ flex: 0.5, width: "100%", marginRight: 8 }}
        value={data?.["@creativeType"]}
        onChange={handleChange("@creativeType")}
      >
        <Select.Option value={"image/jpeg"}>image/jpeg</Select.Option>
        <Select.Option value={"text/html"}>text/html</Select.Option>
      </Select>
      <Input
        style={{ flex: 1, marginLeft: 8 }}
        value={data?.["#"]}
        placeholder={"Resource data"}
        onChange={handleTextChange("#")}
      />
    </div>
  );
};

export const PostBannerComponent: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
}> = ({ data, onChange }) => {
  const handleTextChange = (key: string) => (e: any) => {
    handleChange(key)(e.target.value);
  };

  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };

  return (
    <div>
      <Space wrap>
        <Input
          value={data?.["@width"]}
          placeholder={"MediaFile width"}
          onChange={handleTextChange("@width")}
        />
        <Input
          value={data?.["@height"]}
          placeholder={"MediaFile height"}
          onChange={handleTextChange("@height")}
        />
      </Space>
      <CompanionResourceComponent
        style={{ marginTop: 16 }}
        data={data?.["StaticResource"]}
        onChange={handleChange("StaticResource")}
      />
    </div>
  );
};

export const BannerComponent: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
}> = ({ data, onChange }) => {
  const handleTextChange = (key: string) => (e: any) => {
    handleChange(key)(e.target.value);
  };

  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };
  return (
    <div>
      <Space wrap>
        <Input
          value={data?.["@width"]}
          placeholder={"MediaFile width"}
          onChange={handleTextChange("@width")}
        />
        <Input
          value={data?.["@height"]}
          placeholder={"MediaFile height"}
          onChange={handleTextChange("@height")}
        />
      </Space>
      <CompanionResourceComponent
        style={{ marginTop: 16 }}
        data={data?.["HTMLResource"]}
        onChange={handleChange("HTMLResource")}
      />
    </div>
  );
};

export const VastStyleComponent: React.FC<{
  data: any;
  onChange?: (value: any) => void;
  styles?: string[];
}> = ({ data, onChange, styles }) => {
  const [state, setState] = useState<any>({ ...data });

  const currentVerticalPadding = state?.["@padding"]?.split(" ")[0] ?? 0;
  const currentHorizontalPadding = state?.["@padding"]?.split(" ")[1] ?? 0;

  const currentVerticalMargin = state?.["@margin"]?.split(" ")[0] ?? 0;
  const currentHorizontalMargin = state?.["@margin"]?.split(" ")[1] ?? 0;

  useEffect(() => {
    setState({ ...data });
  }, [data]);

  const handleColorStateChange = (key: string) => (value: any) => {
    handleStateChange(key)(value.hex);
  };

  const handleColorChange = (key: string) => (value: any) => {
    handleChange(key)(value.hex);
  };

  const handleCheckboxChange = (key: string) => (value: any) => {
    handleChange(key)(value.target.checked);
  };

  const updatePaddingState = (horizontal?: number, vertical?: number) => {
    handleStateChange("@padding")(`${vertical ?? 0} ${horizontal ?? 0}`);
  };

  const updatePadding = (horizontal?: number, vertical?: number) => {
    handleChange("@padding")(`${vertical ?? 0} ${horizontal ?? 0}`);
  };

  const updateMarginState = (horizontal?: number, vertical?: number) => {
    handleStateChange("@margin")(`${vertical ?? 0} ${horizontal ?? 0}`);
  };

  const updateMargin = (horizontal?: number, vertical?: number) => {
    handleChange("@margin")(`${vertical ?? 0} ${horizontal ?? 0}`);
  };

  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };

  const handleStateChange = (key: string) => (value: any) => {
    const updatedState = { ...state, [key]: value };
    setState(updatedState);
  };

  return (
    <div>
      <div style={{ display: "flex" }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Title level={4}>Stroke</Typography.Title>
          <SliderPicker
            color={state?.["@stroke"]}
            onChange={handleColorStateChange("@stroke")}
            onChangeComplete={handleColorChange("@stroke")}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Typography.Title level={4}>Fill</Typography.Title>
          <SliderPicker
            color={state?.["@fill"]}
            onChange={handleColorStateChange("@fill")}
            onChangeComplete={handleColorChange("@fill")}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 16 }}>
        <div style={{ marginRight: 8 }}>
          <Checkbox
            checked={state?.["@outlined"]}
            onChange={handleCheckboxChange("@outlined")}
          >
            <Typography.Text strong>Outlined</Typography.Text>
          </Checkbox>
        </div>
        <div style={{ marginLeft: 8 }}>
          <Checkbox
            checked={state?.["@visible"]}
            onChange={handleCheckboxChange("@visible")}
          >
            <Typography.Text strong>Visible</Typography.Text>
          </Checkbox>
        </div>
      </div>
      <Space wrap size={[8, 8]} style={{ marginTop: 16 }}>
        <Select
          style={{ minWidth: 140 }}
          value={state?.["@x"]}
          placeholder={"Horizontal position"}
          onChange={handleChange("@x")}
        >
          <Select.Option value={"left"}>Left</Select.Option>
          <Select.Option value={"center"}>Center</Select.Option>
          <Select.Option value={"right"}>Right</Select.Option>
        </Select>
        <Select
          style={{ minWidth: 140 }}
          value={state?.["@y"]}
          placeholder={"Vertical position"}
          onChange={handleChange("@y")}
        >
          <Select.Option value={"top"}>Top</Select.Option>
          <Select.Option value={"center"}>Center</Select.Option>
          <Select.Option value={"bottom"}>Bottom</Select.Option>
        </Select>
        <Select
          style={{ minWidth: 140 }}
          value={state?.["@fontstyle"]}
          placeholder={"Font style"}
          onChange={handleChange("@fontstyle")}
        >
          <Select.Option value={0}>Normal</Select.Option>
          <Select.Option value={1}>Bold</Select.Option>
          <Select.Option value={2}>Italic</Select.Option>
          <Select.Option value={3}>Bold Italic</Select.Option>
        </Select>
        {styles && (
          <Select
            style={{ minWidth: 140 }}
            placeholder={"Style"}
            value={state?.["@style"]}
            onChange={handleChange("@style")}
          >
            {styles.map((style) => (
              <Select.Option key={style} value={style}>
                {style}
              </Select.Option>
            ))}
          </Select>
        )}
      </Space>
      <div style={{ display: "flex", marginTop: 16 }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Text strong>Opacity</Typography.Text>
          <Slider
            value={state?.["@opacity"] ?? 0}
            onChange={handleStateChange("@opacity")}
            onAfterChange={handleChange("@opacity")}
            min={0.0}
            max={1.0}
            step={0.01}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Typography.Text strong>Hide after</Typography.Text>
          <Slider
            value={state?.["@hideafter"] ?? 0}
            onChange={handleStateChange("@hideafter")}
            onAfterChange={handleChange("@hideafter")}
            min={0}
            max={10}
            step={0.1}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 16 }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Text strong>Vertical padding</Typography.Text>
          <Slider
            value={currentVerticalPadding}
            onChange={(value: number) => {
              updatePaddingState(currentHorizontalPadding, value);
            }}
            onAfterChange={(value: number) => {
              updatePadding(currentHorizontalPadding, value);
            }}
            min={0}
            max={100}
            step={1}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Typography.Text strong>Horizontal padding</Typography.Text>
          <Slider
            value={currentHorizontalPadding}
            onChange={(value: number) => {
              updatePaddingState(value, currentVerticalPadding);
            }}
            onAfterChange={(value: number) => {
              updatePadding(value, currentVerticalPadding);
            }}
            min={0}
            max={100}
            step={1}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 16 }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Text strong>Vertical margin</Typography.Text>
          <Slider
            value={currentVerticalMargin}
            onChange={(value: number) => {
              updateMarginState(currentHorizontalMargin, value);
            }}
            onAfterChange={(value: number) => {
              updateMargin(currentHorizontalMargin, value);
            }}
            min={0}
            max={100}
            step={1}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Typography.Text strong>Horizontal margin</Typography.Text>
          <Slider
            value={currentHorizontalMargin}
            onChange={(value: number) => {
              updateMarginState(value, currentVerticalMargin);
            }}
            onAfterChange={(value: number) => {
              updateMargin(value, currentVerticalMargin);
            }}
            min={0}
            max={100}
            step={1}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 16 }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Text strong>Width</Typography.Text>
          <Slider
            value={state?.["@width"] ?? 0}
            onChange={handleStateChange("@width")}
            onAfterChange={handleChange("@width")}
            min={10}
            max={100}
            step={1}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Typography.Text strong>Height</Typography.Text>
          <Slider
            value={state?.["@height"] ?? 0}
            onChange={handleStateChange("@height")}
            onAfterChange={handleChange("@height")}
            min={10}
            max={100}
            step={1}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 16, alignItems: "center" }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Text strong>Stroke width</Typography.Text>
          <Slider
            value={state?.["@strokewidth"] ?? 0}
            onChange={handleStateChange("@strokewidth")}
            onAfterChange={handleChange("@strokewidth")}
            min={0}
            max={100}
            step={1}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Input
            value={data?.["#"]}
            placeholder={"Content"}
            onChange={(e) => {
              handleChange("#")(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};

const AppodealExtensions: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
}> = ({ data, onChange }) => {
  const [state, setState] = useState<any>({ ...data });

  useEffect(() => {
    setState({ ...data });
  }, [data]);

  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };
  const handleTextChange = (key: string) => (e: any) => {
    handleChange(key)(e.target.value);
  };
  const handleCheckboxChange = (key: string) => (value: any) => {
    handleChange(key)(value.target.checked);
  };
  const handleColorChange = (key: string) => (value: any) => {
    handleChange(key)(value.hex);
  };
  const handleStateChange = (key: string) => (value: any) => {
    const updatedState = { ...state, [key]: value };
    setState(updatedState);
  };
  const handleColorStateChange = (key: string) => (value: any) => {
    handleStateChange(key)(value.hex);
  };

  return (
    <div>
      <div style={{ display: "flex" }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <Typography.Title level={4}>Assets color</Typography.Title>
          <SliderPicker
            color={state?.["AssetsColor"]}
            onChange={handleColorStateChange("AssetsColor")}
            onChangeComplete={handleColorChange("AssetsColor")}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <Typography.Title level={4}>Assets background color</Typography.Title>
          <SliderPicker
            color={state?.["AssetsBackgroundColor"]}
            onChange={handleColorStateChange("AssetsBackgroundColor")}
            onChangeComplete={handleColorChange("AssetsBackgroundColor")}
          />
        </div>
      </div>
      <div style={{ marginTop: 24 }}>
        <Checkbox checked={data?.["R1"]} onChange={handleCheckboxChange("R1")}>
          R1 (redirect on close click)
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox checked={data?.["R2"]} onChange={handleCheckboxChange("R2")}>
          R2 (auto redirect on video playback finished)
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox
          checked={data?.["Autorotate"]}
          onChange={handleCheckboxChange("Autorotate")}
        >
          Autorotate
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox
          checked={data?.["VideoClickable"]}
          onChange={handleCheckboxChange("VideoClickable")}
        >
          Video clickable
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Typography.Text strong>Close time</Typography.Text>
        <Slider
          value={state?.["CloseTime"]}
          onChange={handleStateChange("CloseTime")}
          onAfterChange={handleChange("CloseTime")}
          min={0}
          max={60}
          step={1}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4}>CTA (old)</Typography.Title>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div>
          <Checkbox
            style={{ flex: 0.7, marginRight: 4 }}
            checked={data?.["ShowCta"]}
            onChange={handleCheckboxChange("ShowCta")}
          >
            Show CTA
          </Checkbox>
        </div>
        <div>
          <Input
            style={{ flex: 1, marginRight: 4 }}
            value={data?.["CtaText"]}
            placeholder={"CTA text"}
            onChange={handleTextChange("CtaText")}
          />
        </div>
      </div>
      <Space size={8} style={{ marginTop: 8 }}>
        <Select
          style={{ minWidth: 140 }}
          value={data?.["CtaXPosition"]}
          placeholder={"Cta horizontal position"}
          onChange={handleChange("CtaXPosition")}
        >
          <Select.Option value={"left"}>Left</Select.Option>
          <Select.Option value={"center"}>Center</Select.Option>
          <Select.Option value={"right"}>Right</Select.Option>
        </Select>
        <Select
          style={{ minWidth: 140 }}
          value={data?.["CtaYPosition"]}
          placeholder={"Cta vertical position"}
          onChange={handleChange("CtaYPosition")}
        >
          <Select.Option value={"top"}>Top</Select.Option>
          <Select.Option value={"center"}>Center</Select.Option>
          <Select.Option value={"bottom"}>Bottom</Select.Option>
        </Select>
      </Space>
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4}>Close (old)</Typography.Title>
      </div>
      <Space>
        <Select
          style={{ minWidth: 140 }}
          value={data?.["CloseXPosition"]}
          placeholder={"Close horizontal position"}
          onChange={handleChange("CloseXPosition")}
        >
          <Select.Option value={"left"}>Left</Select.Option>
          <Select.Option value={"center"}>Center</Select.Option>
          <Select.Option value={"right"}>Right</Select.Option>
        </Select>
        <Select
          style={{ minWidth: 140 }}
          value={data?.["CloseYPosition"]}
          placeholder={"Close vertical position"}
          onChange={handleChange("CloseYPosition")}
        >
          <Select.Option value={"top"}>Top</Select.Option>
          <Select.Option value={"center"}>Center</Select.Option>
          <Select.Option value={"bottom"}>Bottom</Select.Option>
        </Select>
      </Space>
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4}>Mute (old)</Typography.Title>
      </div>
      <div>
        <div>
          <Checkbox
            checked={data?.["ShowMute"]}
            onChange={handleCheckboxChange("ShowMute")}
          >
            Show mute
          </Checkbox>
        </div>
        <Space style={{ marginTop: 8 }}>
          <Select
            style={{ minWidth: 140 }}
            value={data?.["MuteXPosition"]}
            placeholder={"Mute horizontal position"}
            onChange={handleChange("MuteXPosition")}
          >
            <Select.Option value={"left"}>Left</Select.Option>
            <Select.Option value={"center"}>Center</Select.Option>
            <Select.Option value={"right"}>Right</Select.Option>
          </Select>
          <Select
            style={{ minWidth: 140 }}
            value={data?.["MuteYPosition"]}
            placeholder={"Mute vertical position"}
            onChange={handleChange("MuteYPosition")}
          >
            <Select.Option value={"top"}>Top</Select.Option>
            <Select.Option value={"center"}>Center</Select.Option>
            <Select.Option value={"bottom"}>Bottom</Select.Option>
          </Select>
        </Space>
      </div>
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4}>Companion (old)</Typography.Title>
      </div>
      <div>
        <Checkbox
          checked={data?.["ShowCompanion"]}
          onChange={handleCheckboxChange("ShowCompanion")}
        >
          Show companion
        </Checkbox>
        <div style={{ flex: 1, marginTop: 8 }}>
          <Typography.Text strong>Companion close time</Typography.Text>
          <Slider
            value={state?.["CompanionCloseTime"]}
            onChange={handleStateChange("CompanionCloseTime")}
            onAfterChange={handleChange("CompanionCloseTime")}
            min={0}
            max={60}
            step={1}
          />
        </div>
      </div>
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4}>Progress (old)</Typography.Title>
      </div>
      <Checkbox
        checked={data?.["ShowProgress"]}
        onChange={handleCheckboxChange("ShowProgress")}
      >
        Show progress
      </Checkbox>
    </div>
  );
};

export const PostBannerStyle: React.FC<{
  data?: any;
  onChange?: (value: any) => void;
}> = ({ data, onChange }) => {
  const handleChange = (key: string) => (value: any) => {
    const updatedData = { ...data, [key]: value };
    onChange?.(updatedData);
  };
  const handleCheckboxChange = (key: string) => (value: any) => {
    handleChange(key)(value.target.checked);
  };
  const handleTextChange = (key: string) => (e: any) => {
    handleChange(key)(e.target.value);
  };

  return (
    <div>
      <div style={{ flex: 1 }}>
        <Typography.Text strong>Close time</Typography.Text>
        <Slider
          value={data?.["CloseTime"]}
          onChange={handleChange("CloseTime")}
          min={0}
          max={60}
          step={1}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <Typography.Text strong>Duration</Typography.Text>
        <Slider
          value={data?.["Duration"]}
          onChange={handleChange("Duration")}
          min={0}
          max={60}
          step={0.5}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox
          checked={data?.["UseNativeClose"]}
          onChange={handleCheckboxChange("UseNativeClose")}
        >
          Use native close
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox
          checked={data?.["IgnoresSafeAreaLayoutGuide"]}
          onChange={handleCheckboxChange("IgnoresSafeAreaLayoutGuide")}
        >
          Ignore safe area
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox checked={data?.["R1"]} onChange={handleCheckboxChange("R1")}>
          R1 (redirect on click)
        </Checkbox>
      </div>
      <div style={{ marginTop: 8 }}>
        <Checkbox checked={data?.["R2"]} onChange={handleCheckboxChange("R2")}>
          R2 (auto redirect after duration or close countdown)
        </Checkbox>
      </div>
      <div>
        <Input
          style={{ flex: 1, marginTop: 8 }}
          value={data?.["ProductLink"]}
          placeholder={"Product Link"}
          onChange={handleTextChange("ProductLink")}
        />
      </div>
      <Collapse style={{ marginTop: 8 }} accordion>
        <Collapse.Panel key={"Countdown"} header={"Countdown"}>
          <VastStyleComponent
            data={data?.["Countdown"]}
            onChange={handleChange("Countdown")}
            styles={["text", "circular"]}
          />
        </Collapse.Panel>
        <Collapse.Panel key={"ClosableView"} header={"ClosableView"}>
          <VastStyleComponent
            data={data?.["ClosableView"]}
            onChange={handleChange("ClosableView")}
            styles={["cross", "crossfill", "skip", "skipfill"]}
          />
        </Collapse.Panel>
        <Collapse.Panel key={"LoadingView"} header={"LoadingView"}>
          <VastStyleComponent
            data={data?.["LoadingView"]}
            onChange={handleChange("LoadingView")}
          />
        </Collapse.Panel>
        <Collapse.Panel key={"Progress"} header={"Progress"}>
          <VastStyleComponent
            data={data?.["Progress"]}
            onChange={handleChange("Progress")}
            styles={[
              "text",
              "text-reverse",
              "circular",
              "circular-reverse",
              "linear",
              "linear-reverse",
            ]}
          />
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

let currentPreviewBuildTask: CancelablePromiseType<any> | undefined = undefined;

interface VastStore {
  creative?: any;
  postBanner?: any;
  banner?: any;
  extension?: any;
  baseExtension?: any;
}

const defaultCreativeData = {
  Duration: "00:00:16",
  VideoClicks: {
    ClickThrough: "https://google.com",
  },
  MediaFiles: {
    MediaFile: {
      "#": "https://iab-publicfiles.s3.amazonaws.com/vast/VAST-4.0-Short-Intro.mp4",
      "@width": 400,
      "@height": 300,
      "@type": "video/mp4",
    },
  },
};

const defaultPostBanner = {
  "@width": 320,
  "@height": 480,
  StaticResource: {
    "@creativeType": "image/jpeg",
    "#": "https://cdn.liftoff.io/customers/526d4a23be/images/v1/a28e518737085aa569a6.jpg",
  },
};

const defaultBanner = {
  "@width": 300,
  "@height": 200,
  HTMLResource: {
    "@creativeType": "text/html",
    "#": "<![CDATA[ <!DOCTYPE html><html lang='en'><head><meta charset='utf-8'><meta name='viewport' content='width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1'><title>orientated banner</title><style>html,body {margin: 0;padding: 0;width: 100%;height: 100%;} a .banner {position: absolute;top: 0;left: 0;width: 100%; height: 100%; background-size: cover; background-repeat: no-repeat; background-position: center;} @media screen and (orientation:landscape) { a .banner{background-image: url('http://s3.amazonaws.com/appodeal-campaign-images/development/campaign_images/images/000/001/479/original/10_1024x768.jpg?1474475545');}} @media screen and (orientation:portrait) { a .banner {background-image: url('https://image-cdn-max.appodeal.com/appodeal-campaigns-images/staging/campaign_images/images/000/001/639/original/11_768x1024.jpg?1477398090');}}</style></head><body><a href='appodeal://'><div class='banner'></div></a></body></html> ]]>",
  },
};

const VastSaveDialog: React.FC<{
  visible: boolean;
  onClose: () => void;
  onFinish: (path: string) => void;
}> = ({ visible, onClose, onFinish }) => {
  const [form] = useForm();

  const handleFinish = async (values: any) => {
    onFinish(`/${values.path}.xml`);
  };

  return (
    <Modal visible={visible} onOk={() => form.submit()} onCancel={onClose}>
      <Form form={form} onFinish={handleFinish} style={{ marginTop: 32 }}>
        <Form.Item
          name={["path"]}
          required={true}
          rules={[
            {
              required: true,
              validateTrigger: ["onSubmit"],
              validator: async (_, value) => {
                if (isEmpty(value)) {
                  return Promise.reject("Required");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder={"File path"} prefix={"/"} suffix={".xml"} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const VastBuilderPage: React.FC<{}> = () => {
  const [distributeKey] = useLocalStorage("distributeKey", uuidv4());
  const [currentPath, setCurrentPath] = useState<string>(
    `/_tmp/${distributeKey}.xml`
  );

  const [store, setStore] = useState<VastStore>({
    creative: defaultCreativeData,
    postBanner: defaultPostBanner,
    banner: defaultBanner,
  });

  const handleStoreUpdate = (value: Partial<VastStore>) => {
    setStore((prevState) => ({ ...prevState, ...value }));
  };
  const handleCreativeUpdate = (value: any) =>
    handleStoreUpdate({ creative: value });
  const handlePostBannerUpdate = (value: any) =>
    handleStoreUpdate({ postBanner: value });
  const handleBannerUpdate = (value: any) =>
    handleStoreUpdate({ banner: value });

  const setExtension = (data: any) => handleStoreUpdate({ extension: data });
  const handleExtensionUpdate = (key?: string) => (data: any) => {
    const dataToUpdate = key ? { [key]: data } : data;
    handleStoreUpdate({ extension: { ...store.extension, ...dataToUpdate } });
  };
  const handleBaseExtensionUpdate = (key?: string) => (data: any) => {
    const dataToUpdate = key ? { [key]: data } : data;
    handleStoreUpdate({
      baseExtension: { ...store.baseExtension, ...dataToUpdate },
    });
  };

  const [qrPath, setQrPath] = useState<string | undefined>();
  const [xmlPreviewData, setXmlPreviewData] = useState<string>("");

  const build = useCallback(() => {
    return {
      VAST: {
        Ad: {
          InLine: {
            Creatives: {
              Creative: [
                {
                  Linear: {
                    ...store.creative,
                  },
                },
                ...(store.postBanner
                  ? [
                      {
                        CompanionAds: {
                          Companion: {
                            ...store.postBanner,
                          },
                        },
                      },
                    ]
                  : []),
              ],
            },
            Extensions: {
              Extension: {
                "@type": "appodeal",
                ...store.extension,
                ...store.baseExtension,
                ...(store.banner && {
                  Companion: {
                    ...store.banner,
                  },
                }),
              },
            },
          },
        },
      },
    };
  }, [store]);

  const updateXmlPreview = useCallback(async () => {
    return beautify.html(xmlbuilder.create(build()).end());
  }, [build]);

  useEffect(() => {
    currentPreviewBuildTask?.cancel();
    currentPreviewBuildTask = cancelable(updateXmlPreview());
    currentPreviewBuildTask.then((data) => {
      setXmlPreviewData(data);
    });
  }, [updateXmlPreview]);

  const handleSaveAction = (path: string, showQr?: boolean) => () => {
    const data = xmlbuilder.create(build()).end();
    return firebase
      .storage()
      .ref(path)
      .putString(data)
      .then((_) => {
        if (showQr) {
          setQrPath(path);
        } else {
          message.success(`You xml was updated (path: ${path})`);
        }
      })
      .catch((e) => {
        console.log("e: " + e);
      });
  };

  const removeKeyAction = (key: string, data: any, updateMethod: any) => () => {
    delete data[key];
    updateMethod({ ...data });
  };

  const ResetView: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
      <RedoOutlined
        onClick={(e) => {
          onClick();
          e.stopPropagation();
        }}
      />
    );
  };

  const [isSaveDialogVisible, setSaveDialogVisible] = useState(false);
  const [isCreativePickerVisible, setCreativePickerVisible] = useState(false);

  const handleLoad = async (item: StorageItem) => {
    item.ref.getDownloadURL().then((res) => {
      return axios.get(res).then((res) => {
        const data = res.data;
        let obj = xmlbuilder.create(data).toObject() as any;

        function replacePropertyValue(prevVal: any, newVal: any, object: any) {
          const newObject = clone(object);
          each(object, (val: any, key: any) => {
            if (val === prevVal) {
              newObject[key] = newVal;
            } else if (typeof val === "object" || isArray(val)) {
              newObject[key] = replacePropertyValue(prevVal, newVal, val);
            }
          });
          return newObject;
        }

        obj = replacePropertyValue("false", false, obj);
        obj = replacePropertyValue("true", true, obj);
        const {
          Video,
          LoadingView,
          Countdown,
          Progress,
          ClosableView,
          Mute,
          CTA,
          RepeatView,
          Postbanner,
          Companion,
          ...restExtensions
        } = obj?.["VAST"]?.Ad?.InLine?.Extensions?.Extension;
        setStore({
          creative: obj?.["VAST"]?.Ad?.InLine?.Creatives?.Creative?.[0]?.Linear,
          postBanner:
            obj?.["VAST"]?.Ad?.InLine?.Creatives?.Creative?.[1]?.CompanionAds
              ?.Companion,
          banner: obj?.["VAST"]?.Ad?.InLine?.Extensions?.Extension?.Companion,
          extension: {
            Video,
            LoadingView,
            Countdown,
            Progress,
            ClosableView,
            Mute,
            CTA,
            RepeatView,
            Postbanner,
          },
          baseExtension: restExtensions,
        });
        setCurrentPath(`/${item.ref.fullPath}`);
      });
    });
  };

  return (
    <div
      style={{
        overflow: "hidden",
        height: "100%",
        display: "flex",
        padding: 0,
      }}
    >
      <div
        style={{
          flex: 1,
          marginRight: 8,
          overflowY: "scroll",
          paddingTop: 16,
          paddingBottom: 16,
        }}
      >
        <Typography.Title level={4}>Creatives & Banners</Typography.Title>
        <Collapse style={{ marginBottom: 16 }} accordion>
          <Collapse.Panel key={"Creative"} header={"Creative"}>
            <CreativeComponent
              data={store.creative}
              onChange={handleCreativeUpdate}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"PostBanner"}
            header={"Post Banner"}
            extra={
              <ResetView
                onClick={removeKeyAction("postBanner", store, setStore)}
              />
            }
          >
            <PostBannerComponent
              data={store.postBanner}
              onChange={handlePostBannerUpdate}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"Banner"}
            header={"Banner"}
            extra={
              <ResetView onClick={removeKeyAction("banner", store, setStore)} />
            }
          >
            <BannerComponent
              data={store.banner}
              onChange={handleBannerUpdate}
            />
          </Collapse.Panel>
        </Collapse>
        <Typography.Title level={4}>Appodeal extensions</Typography.Title>
        <Collapse accordion destroyInactivePanel={true}>
          <Collapse.Panel key={"Base"} header={"Base"}>
            <AppodealExtensions
              data={store.baseExtension}
              onChange={handleBaseExtensionUpdate()}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"Video"}
            header={"Video"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "Video",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["Video"]}
              onChange={handleExtensionUpdate("Video")}
              styles={["fullscreen", "inline"]}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"LoadingView"}
            header={"LoadingView"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "LoadingView",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["LoadingView"]}
              onChange={handleExtensionUpdate("LoadingView")}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"Countdown"}
            header={"Countdown"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "Countdown",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["Countdown"]}
              onChange={handleExtensionUpdate("Countdown")}
              styles={["text", "circular"]}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"Progress"}
            header={"Progress"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "Progress",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["Progress"]}
              onChange={handleExtensionUpdate("Progress")}
              styles={[
                "text",
                "text-reverse",
                "circular",
                "circular-reverse",
                "linear",
                "linear-reverse",
              ]}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"ClosableView"}
            header={"ClosableView"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "ClosableView",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["ClosableView"]}
              onChange={handleExtensionUpdate("ClosableView")}
              styles={["cross", "crossfill", "skip", "skipfill"]}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"Mute"}
            header={"Mute"}
            extra={
              <ResetView
                onClick={removeKeyAction("Mute", store.extension, setExtension)}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["Mute"]}
              onChange={handleExtensionUpdate("Mute")}
              styles={["speaker", "speakerfill"]}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"CTA"}
            header={"CTA"}
            extra={
              <ResetView
                onClick={removeKeyAction("CTA", store.extension, setExtension)}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["CTA"]}
              onChange={handleExtensionUpdate("CTA")}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"RepeatView"}
            header={"RepeatView"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "RepeatView",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <VastStyleComponent
              data={store.extension?.["RepeatView"]}
              onChange={handleExtensionUpdate("RepeatView")}
              styles={["repeat", "repeatfill"]}
            />
          </Collapse.Panel>
          <Collapse.Panel
            key={"Postbanner"}
            header={"Postbanner"}
            extra={
              <ResetView
                onClick={removeKeyAction(
                  "Postbanner",
                  store.extension,
                  setExtension
                )}
              />
            }
          >
            <PostBannerStyle
              data={store.extension?.["Postbanner"]}
              onChange={handleExtensionUpdate("Postbanner")}
            />
          </Collapse.Panel>
        </Collapse>
      </div>
      <div
        style={{
          flex: 1,
          marginLeft: 8,
          paddingTop: 16,
          paddingBottom: 16,
        }}
      >
        <Space>
          <Button
            onClick={handleSaveAction(currentPath)}
            type={"primary"}
            size={"large"}
          >
            Update it!
          </Button>
          <Button
            onClick={handleSaveAction(currentPath, true)}
            type={"primary"}
            size={"large"}
          >
            Qr it!
          </Button>
          <Button
            onClick={() => {
              setCreativePickerVisible(true);
            }}
            type={"primary"}
            size={"large"}
          >
            Load from
          </Button>
          <Button
            onClick={() => setSaveDialogVisible(true)}
            type={"primary"}
            size={"large"}
          >
            Save as
          </Button>
        </Space>
        <div>
          <Typography.Text type={"secondary"}>{currentPath}</Typography.Text>
        </div>
        <div style={{ marginTop: 16 }}>
          <AceEditor
            mode={"xml"}
            theme="xcode"
            height={"500px"}
            width={"100%"}
            value={xmlPreviewData}
          />
        </div>
      </div>
      <CreativeQrCode
        childPath={qrPath}
        onCancel={() => setQrPath(undefined)}
      />
      <Modal
        visible={isCreativePickerVisible}
        destroyOnClose={true}
        onCancel={() => {
          setCreativePickerVisible(false);
        }}
      >
        <div style={{ marginTop: 32 }}>
          <CreativesListComponent
            onItemClick={(item) => {
              handleLoad(item);
              setCreativePickerVisible(false);
            }}
          />
        </div>
      </Modal>
      <VastSaveDialog
        visible={isSaveDialogVisible}
        onFinish={(path) => {
          setCurrentPath(path);
          setSaveDialogVisible(false);
          handleSaveAction(path, false)();
        }}
        onClose={() => {
          setSaveDialogVisible(false);
        }}
      />
    </div>
  );
};
